<template>
  <router-link
    tag="div"
    :to="'/me/scenarios/' + directory.uuid"
    class="d-flex flex-column directory-row"
  >
    <div class="d-flex text-isim-light">
      <span
        :class="{
          'material-icons mx-1 folder-icon': true,
          selected: isCurrentDirectory,
        }"
      >
        folder
      </span>
      {{ directory.name }}
    </div>

    <RecursiveDirectoryTree
      v-for="child in directory.children"
      :directory="child"
    />
  </router-link>
</template>

<script>
export default {
  name: "RecursiveDirectoryTree",
  props: ["directory"],
  computed: {
    isCurrentDirectory() {
      return this.$route.params.directoryUuid === this.directory.uuid;
    },
  },
};
</script>

<style scoped>
.folder-icon {
  color: var(--isim-light-icon);
}
.folder-icon.selected {
  color: var(--isim-primary);
}

.text-isim-light {
  color: var(--isim-light-text);
}

.directory-row {
  margin-top: 2px;
  margin-bottom: 2px;
  padding-left: 22px;
}
</style>
